import { MESSAGE_ERROR, MESSAGE_SUCCESS } from './mutations_type'

import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import game from './modules/game'
import giftcode from './modules/giftcode'
import server from './modules/server'
import slider from './modules/slider'
import user from './modules/user'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    status: {
      loading_giftcode: true,
      loading_unique: true,
      loading_generic: true,
      loading_vip: true,
      loading_open: true,
      loading_history: true,
      loading_dialog: true,
      loading_game: true,
      login_required: false,
    },
    code: '',
    message_error: {
      msg: '',
      status: Boolean,
    },
    message_success: {
      msg: '',
      status: Boolean,
    },
    game_name_item: '',
    totalCodes: 1,
  },
  getters: {
    MESSAGE_ERROR: state => {
      return state.message_error
    },
    MESSAGE_SUCCESS: state => {
      return state.message_success
    },
  },
  mutations: {
    login_required(state, login_required) {
      state.status.login_required = login_required
    },
    loading_giftcode(state, loading_giftcode) {
      state.status.loading_giftcode = loading_giftcode
    },
    loading_unique(state, loading_unique) {
      state.status.loading_unique = loading_unique
    },
    loading_generic(state, loading_generic) {
      state.status.loading_generic = loading_generic
    },
    loading_vip(state, loading_vip) {
      state.status.loading_vip = loading_vip
    },
    loading_open(state, loading_open) {
      state.status.loading_open = loading_open
    },
    loading_history(state, loading_history) {
      state.status.loading_history = loading_history
    },
    loading_dialog(state, loading_dialog) {
      state.status.loading_dialog = loading_dialog
    },
    loading_game(state, loading_game) {
      state.status.loading_game = loading_game
    },
    updateCode(state, code) {
      state.code = code
    },
    totalCodes(state, totalCodes) {
      state.totalCodes = totalCodes
    },
    [MESSAGE_ERROR]: (state, payload) => {
      state.message_error.status = true
      state.message_error.msg = payload
    },
    [MESSAGE_SUCCESS]: (state, payload) => {
      state.message_success.status = true
      state.message_success.msg = payload
    },
    gameNameItem(state, game_name_item) {
      state.game_name_item = game_name_item
    },
  },
  actions: {},
  modules: {
    user,
    auth,
    slider,
    game,
    giftcode,
    server,
  },
})
